import { Pipe, PipeTransform } from '@angular/core';
import { Learning_Type } from '@app/enums/_index';

@Pipe({
  name: 'showDurationByInstructionType',
  standalone: false,
})
export class ShowDurationByInstructionTypePipe implements PipeTransform {
  /**
   * Return boolean to indicate if the duration should show for a given instruction type
   * @param learningType - learning type to transform formatted duration string
   * @param showDuration - Optional. Show duration in some scenarios like session for course detail
   * @returns formatted duration string
   */
  transform(learningType: string, showDuration?: boolean): boolean {
    switch (learningType) {
      case Learning_Type.SUBSCRIPTION:
        return false;
      case Learning_Type.WEBINAR:
      case Learning_Type.E_LEARNING:
        return true;
      case Learning_Type.CERTIFICATION_EXAM:
        return false;
      case Learning_Type.SELF_STUDY:
      case Learning_Type.INSTRUCTOR_LED:
      case Learning_Type.INSTRUCTOR_LED_IN_PERSON:
      case Learning_Type.INSTRUCTOR_LED_VIRTUAL:
      case Learning_Type.INSTRUCTOR_LED_IN_PERSON:
      case Learning_Type.QUICK_LEARNING:
      case Learning_Type.VIRTUAL:
      case Learning_Type.IN_PERSON:
      case Learning_Type.WORKSHOP:
        if (showDuration) {
          return true;
        } else {
          return false;
        }
      default:
        return false;
    }
  }
}
